app.controller('OrderQuoteArchiveController', ['$rootScope', '$scope', '$http', '$state', function ($rootScope, $scope, $http, $state) {

    $scope.search_model = new $rootScope.model_constructor.SearchModel();

    $scope.quote_list_model = new $rootScope.model_constructor.ListModel();

    $scope.archiveSearch = function () {

        const searchModel = $scope.search_model;
        searchModel.prepare();

        $rootScope.service.order_history.requestArchive("webquote", $scope.quote_list_model, searchModel);
    };

    $scope.showOrder = function (order) {
        $state.go('myba.order-quote-saved-entry.entry', {order_id: order._id});

    };

    $scope.startNewQuote = function () {
        $rootScope.service.order.startNewOrder(true);
        $state.go('myba.dashboard');
    }
}]);